import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { DishServices } from "../../../../dish/services";
import { Globals } from "../../../../../globals";
import { SchoolServices } from '../../../services';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the MenuPartialDishesSelectPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-classrooms-partial-students-select',
    templateUrl: 'classrooms-partial-students-select.html',
})
export class ClassroomsPartialStudentsSelectPage {


    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public dishServices: DishServices,
        public globals: Globals,
        private toastCtrl: ToastController,
        public schoolServices: SchoolServices,
        public translate: TranslateService) {

        this.schoolServices.getStudents(this.globals.school_uid);


    }

    async insert(student) {
        //Funcion que añadir al array de platos seleccionados para el menu
        if (!this.check(student.UID)) { //Buscamos si el plato ya esta anadido
            var _array = Array();

            _array.push(student.UID); //UID
            _array.push(student.name);
            _array.push(student.email);

            this.schoolServices.classroom_students_array_tmp.push(_array);
        } else {
            let toast = this.toastCtrl.create({
                message: this.translate.instant('instant-alumno-esta-anadido-lista'),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
        }
    }

    check(value) {
        var response = false;
        for (var i = 0; i < this.schoolServices.classroom_students_array_tmp.length; i++) {
            var obj = this.schoolServices.classroom_students_array_tmp[i];
            if (obj[0] == value) {
                response = true;
            }
        }
        return response;
    }

}


// WEBPACK FOOTER //
// ./src/pages/schools/classrooms-create/classrooms-create-students-select/classrooms-partial-students-select/classrooms-partial-students-select.ts